import request from '@/utils/request'

// 查询广告信息列表分页
export function fetchList(query) {
    return request({
        url: '/banner/banner-type/page',
        method: 'get',
        params: query,
    })
}
// 查询广告信息列表不分页
export function typeList(query) {
    return request({
        url: '/banner/banner-type/way/page',
        method: 'get',
        params: query,
    })
}
// 查询广告详细
export function getObj(id) {
    return request({
        url: '/banner/banner-type/detail?id=' + id,
        method: 'get',
    })
}
// 新增广告
export function addObj(data) {
    return request({
        url: '/banner/banner-type/add',
        method: 'post',
        data: data,
    })
}
// 修改广告
export function putObj(data) {
    return request({
        url: '/banner/banner-type/edit',
        method: 'post',
        data: data,
    })
}
// 删除广告
export function delObj(data) {
    return request({
        url: '/fix/model/delete',
        method: 'post',
        data: data,
    })
}